import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import useBreakpoint from '@/composables/useBreakpoint'
  import type { PropType } from 'vue'
  import type { CourseItem } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TagFilter',
  props: {
    courses: {
      required: true,
      type: Array as PropType<CourseItem[]>,
    },
    tags: {
      required: true,
      type: Array as PropType<{ id: string; title: string }[]>,
    },
  },
  emits: ['active-tag'],
  setup(__props, { emit }) {

const props = __props;

  
  

  const { isMobileDevice } = useBreakpoint()
  const activeTag = ref('')

  const totalCourses = computed(() => {
    if (activeTag.value === '') return props.courses.length
    return props.courses.filter((course) => course.tags?.some((tag) => tag.id === activeTag.value)).length
  })

  const setActiveTag = (tag: string): void => {
    activeTag.value = tag
    emit('active-tag', tag)
  }

return { __sfc: true,props, emit, isMobileDevice, activeTag, totalCourses, setActiveTag, computed, ref, useBreakpoint }
}

})